import {ErrorMessage, Field, Form, Formik} from 'formik'
import {KTSVG} from '../../../helpers'
import {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {getRequest, postRequest} from '../../../../app/pages/Helpers/Requests'
import * as Yup from 'yup'
import toast from 'react-hot-toast'
import PushLocation from './PushLocation'

function PushTariff() {
  let {pointId} = useParams()
  const [tariffs, setTariffs] = useState<any[]>([])

  // Initial values for Formik
  const initialValues = {
    tariffId: '',
  }

  // Handle Submit
  const handleSubmit = async (values: any, {setSubmitting, resetForm}: any) => {
    try {
      const payload = {
        mspId: pointId,
        tariffId: values.tariffId,
      }
      console.log('Payload being sent:', payload)
      const res = await postRequest(`/ocpi/tariffs/push`, payload)
      if (res && res.data) {
        console.log('Push Tariff Success:', res.data)
        toast.success('Tariff pushed successfully!')
        resetForm()
      }
    } catch (error) {
      console.error('Error pushing tariff:', error)
      toast.error('Failed to push tariff.')
    } finally {
      setSubmitting(false)
    }
  }

  // Fetch Locations
  const getTariffs = async () => {
    try {
      const res = await getRequest(`/tariff`)
      console.log('tariff response', res?.data.data.tariffs)
      if (res && res.data) {
        setTariffs(res.data.data.tariffs)
      }
    } catch (error: any) {
      console.error('Error fetching tariff:', error)
    }
  }

  useEffect(() => {
    getTariffs()
  }, [])

  return (
    <div className='modal fade' tabIndex={-1} id='get_push_tariff'>
      <div className='modal-dialog modal-lg'>
        <div className='modal-content'>
          <div className='modal-header bg-success'>
            <h5 className='modal-title text-white'>Push Tariff</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-success ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmit}
            >
              {({isSubmitting}) => (
                <Form>
                  {/* Tariff Dropdown */}
                  <div className='col-md-12 mt-3'>
                    <label className='form-label'>Select Tariff</label>
                    <Field as='select' name='tariffId' className='form-control'>
                      <option value=''>-- Select Tariff --</option>
                      {tariffs.map((tariff, index) => (
                        <option key={index} value={tariff.id}>
                          {tariff.name}, {tariff.price}, {tariff.currency}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage name='tariffId' component='div' className='text-danger' />
                  </div>

                  <div className='modal-footer mt-3'>
                    <button type='button' className='btn btn-light-danger' data-bs-dismiss='modal'>
                      Cancel
                    </button>
                    <button type='submit' disabled={isSubmitting} className='btn btn-light-success'>
                      {isSubmitting ? 'Submitting...' : 'Submit'}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PushTariff
